import React from 'react';

const AIDivider = (props) => {
    return (
        <svg width="1" height="20" viewBox="0 0 1 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="0.25" x2="0.25" y2="20" stroke="#C8C6C4" strokeWidth="0.5" />
        </svg>
    );
}

export default AIDivider;